import { FLAVORS, Flavor } from "pinata-common/flavors";

export const flavor = ((globalThis as any).PINATA_FLAVOR || "pinata") as Flavor;
export const flavorDomain = FLAVORS[flavor]?.domain;

export const isPinata = flavor === "pinata";
